import React from "react";
import { Helmet } from "react-helmet";
import '../index.css';
import "../css/home.css"
import Navbar from "./navbar";
import Footer from "./footer";
import sample from "../data/sample";

import Banner from "./home_components/banner";
import Features from "./home_components/Features"
import SmolBanner from "./home_components/SmolBanner"
import ItemCrousel from "./home_components/ItemCrousel";
import baseUrl from "../base_url";

let apiBaseUrl = baseUrl

function HomePageContent(){

    const [ladies_products , set_ladies_products] = React.useState(sample) ;
    const [newArrival , setNewArrival] = React.useState(sample)

    React.useEffect(()=>{   
        const fetchData = async () => {
            try {
                let response = await fetch(`${apiBaseUrl}api/products/data/new-arrival`);
                let data = await response.json(); 
                setNewArrival(data.data)

                response = await fetch(`${apiBaseUrl}api/products/data/ladies?limit=30`);
                data = await response.json()
                set_ladies_products(data.data)
            } catch (error) {
                console.error("Error fetching the data:", error);
            }
        };
        fetchData();
    } , [])

    return(
        <div className="home_page_content">
            <Helmet>
                <title>Buy Latest Fashion | Trendy Clothes for Men, Women & Kids</title>
                <meta name="description" content="Shop the latest fashion trends in women's, men's, and kids' clothing at unbeatable prices. Explore new arrivals and bestsellers now!" />
                <meta name="keywords" content="fashion, online shopping, trendy clothes, men's fashion, women's fashion, kids' wear" />
                <script type="application/ld+json">
                {JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "Product",
                    "name": "Women's Trending Bestsellers",
                    "image": "https://example.com/image.jpg",
                    "description": "Discover the latest trending fashion in women's wear",
                    "brand": {
                        "@type": "Brand",
                        "name": "YourBrandName"
                    }
                })}
                </script>
            </Helmet>
            <Features/> 
            <Banner
                heading_above={true}
                heading={"New arrivals"}
                // support_text={"An exclusive holiday edit"}
                position={"center"}
                src="https://image.hm.com/content/dam/global_campaigns/season_01/women/ws21g/WS21G-new-3x2_2.jpg?imwidth=1536"
                link={"/store/ladies"}
                color={"white"}
                className={"red_banner"}
                alt="The 2025 Festive Edit - An Exclusive Holiday Collection"
            />




            <Banner
                heading_above = {true}
                heading = {"Linen days"}
                support_text = {"Airy and polished summer looks."}
                position = {"left"}
                src= {"https://image.hm.com/content/dam/global_campaigns/season_01/men/ms21e5/common-ratios/MS21E5-linen-days-teaser-3x2.jpg?imwidth=1536"}
                link = {"/store/men"}
                color = {"white"}
                className =  {"move"}
            />

            <SmolBanner
                bg_src="https://lp2.hm.com/hmgoepprod?source=url[https://www2.hm.com/content/dam/global_campaigns/season_09/ladies/6049a/6049A-3x1-spring-2024.jpg]&scale=size[960]&sink=format[jpeg],quality[80]"
                color={"black"}
                heading={"The T-shirt shop starting $399"}
                support_text={"From bold graphics to basics: new trending tees for a fashionable update"}
                buttons={
                    [{href : "store/ladies" , text : "Ladies"} , {href : "store/men" , text : "Men"}  , {href : "store/kids" , text : "Kids & baby"}]
                }
            />

            <ItemCrousel
                data={newArrival}
                label={"New Arrivals"}
                size={"larger"}
            />
            
            <Banner
                heading_above = {true}
                heading = {"Georgia Beaumont H&M"}
                support_text = {"Premium Kids Fashion."}
                position = {"center"}
                src= {"https://image.hm.com/content/dam/global_campaigns/season_01/baby/ks21c/KS21C-Georgia-Beaumont-baby-3x2.jpg?imwidth=1536"}
                link = {"/store/kids"}
                color = {"black"}
                className =  {"kids"}
            />


{/* 
            <ItemCrousel
                data={ladies_products}
                label={"Women's trending bestsellers 🖤"}
                size={"smaller"}
            /> */}

            <Banner
                heading_above = {true}
                heading = {"Preppy edit"}
                // support_text = {"Dreamy dress edit"}
                position = {"center"}
                src= {"https://image.hm.com/content/dam/global_campaigns/season_01/women/ds21e/DS21E-3x2.jpg?imwidth=1536"}
                link = {"/store/ladies"}
                color = {"black"}
                className =  {"dreamy"}
            />

            <SmolBanner
                bg_src = {"https://lp2.hm.com/hmgoepprod?source=url[https://www2.hm.com/content/dam/global_campaigns/season_00/home/7000a/7000A-2x1.jpg]&scale=size[960]&sink=format[jpeg],quality[80]"}
                color = {"white"}
                heading = {"Home: New Arrivals"}
                support_text = {"Selection of most loved pieces!"}
                buttons = {
                    [{href : "/store/home" , text : "Shop now"}]
                }
            />

        </div>
    )
}

function HomePage(){
    React.useEffect(() => {
        document.title = "Jutexx | Home Page";
    }, []);
    return(
        <div className="home_page">
            <Navbar/>
            <div className="content_div">
                <HomePageContent/>
            </div>
            <Footer/>
        </div>
    )
}

export default HomePage;